import type { SxProps, Theme } from "@mui/material";

export const customScrollbar = {
  scrollbarWidth: "thin",
  scrollbarColor: (theme: Theme) => `${theme.palette.grey["500"]} transparent`,
} satisfies SxProps<Theme>;
